import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import settings from '@/settings.js';

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import Tabla from '@/views/Tabla'
import Izdaja from '@/views/Izdaja'
import Kupci from '@/views/Kupci'
import Prilivi from '@/views/Prilivi'
import Profile from '@/views/Profile'
import Uporabniki from '@/views/Uporabniki'
import Login from '@/views/Login'
import Povracila from '@/views/Povracila'
import Aktivnosti from '@/views/Aktivnosti'
import HotelGum from '@/views/HotelGum'

Vue.use(Router)

let router = new Router({
	mode: 'hash',
	linkActiveClass: 'open active',
	scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: '/',
			name: 'Zaloga',
			redirect: to => {
				if (!store.getters.user) {
					return 'auth';
				} else if (settings.hotelGumRoles.includes(store.getters.user.role)) {
					return 'hotel';
				} else if (settings.poprodajaRoles.includes(store.getters.user.role)) {
					return 'izdaja';
				} else {
					return 'dashboard';
				}
			},
			component: Full,
			children: [
				{
					path: '/dashboard',
					name: 'Domov',
					component: Dashboard,
					meta: {
						requiresAuth: true,
						permissions: settings.vozilaRoles.concat(settings.highPermissionsRoles)
					}
				},
				{
					path: '/aktivnosti',
					name: 'Aktivnosti',
					component: Aktivnosti,
					meta: {
						requiresAuth: true,
						permissions: settings.vozilaRoles.concat(settings.highPermissionsRoles)
					}
				},
				{
					path: '/tabla',
					name: 'Tabla vozil',
					component: Tabla,
					meta: {
						requiresAuth: true,
						permissions: settings.vozilaRoles.concat(settings.highPermissionsRoles)
					}
				},
				{
					path: '/izdaja',
					name: 'Izdaja vozil',
					component: Izdaja,
					meta: {
						requiresAuth: true,
						permissions: settings.poprodajaRoles.concat(settings.vozilaRoles.concat(settings.highPermissionsRoles))
					}
				},
				{
					path: '/kupci',
					name: 'Kupci',
					component: Kupci,
					meta: {
						requiresAuth: true,
						permissions: settings.vozilaRoles.concat(settings.highPermissionsRoles)
					}
				},
				{
					path: '/prilivi',
					name: 'Prilivi',
					component: Prilivi,
					meta: {
						requiresAuth: true,
						permissions: settings.vozilaRoles.concat(settings.highPermissionsRoles)
					}
				},
				{
					path: '/povracila',
					name: 'Povracila',
					component: Povracila,
					meta: {
						requiresAuth: true,
						permissions: settings.vozilaRoles.concat(settings.highPermissionsRoles)
					}
				},
				{
					path: '/profile',
					name: 'Profil',
					component: Profile,
					meta: {
						requiresAuth: true,
						permissions: settings.vozilaRoles.concat(settings.highPermissionsRoles)
					}
				},
				{
					path: '/nastavitve',
					redirect: '/nastavitve/uporabniki',
					name: 'Nastavitve',
					component: {
						render (c) { return c('router-view') }
					},
					children: [
						{
							path: 'uporabniki',
							name: 'Uporabniki',
							component: Uporabniki
						}
					],
					meta: {
						requiresAuth: true,
						permissions: settings.highPermissionsRoles
					}
				},
				{
					path: '/hotel',
					name: 'Hotel gum',
					component: HotelGum,
					meta: {
						requiresAuth: true,
						permissions: settings.poprodajaRoles.concat(settings.hotelGumRoles.concat(settings.highPermissionsRoles))
					}
				}
			]
		},
		{
			path: '/auth',
			redirect: '/auth/login',
			name: 'Auth',
			component: {
				render (c) { return c('router-view') }
			},
			children: [
				{
					path: '/auth/login',
					name: 'Prijava',
					component: Login
				}
			]
		}
	]
});
router.beforeEach((to, from, next) => {
	let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	if (requiresAuth && !store.getters.user) {
		next('/auth/login');
	} else {
		let isAccessDenied = to.matched.some((record) => {
			if (record.meta.permissions) {
				return !record.meta.permissions.includes(store.getters.user.role);
			} else {
				return false;
			}
		});
		if (isAccessDenied) {
			next(false);
		} else {
			next();
		}
	}
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js